import styled from 'styled-components';
import { wrapper } from 'globalStyles'
const Wrapper = styled.div`
  ${wrapper}
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/containers/AccountPage/Wrapper.js